
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { PalletListItem } from "@/models/api/barcodeSystem/inventory/pallets";

const inventoryModuleState = getModule(InventoryModule);

import draggable from "vuedraggable";

import RightClickMenu from "@/components/widgets/RightClickMenu.vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    RightClickMenu,
    draggable
  }
})
export default class InventorySummaryTable extends Vue {
  @Prop({ default: "table" })
  public id: string;

  @Prop({ default: "" })
  public containerClass: string;

  @Prop({ default: null })
  public tableField: Array<any>;

  @Prop({ default: null })
  public tableMenuItem: Array<any>;

  public rightClickLocation: any = null;
  public showHelp: boolean = false;
  public draggingData: boolean = false;

  get filterFields() {
    let filterFields = this.tableField.filter(
      field => field.hidden === false && field.key !== "selected"
    );
    return filterFields;
  }

  set filterFields(newValue) {
    this.$emit("updateFields", newValue);
  }

  get pallets(): Array<PalletListItem> {
    return inventoryModuleState.palletData;
  }

  get loading(): boolean {
    return inventoryModuleState.loading;
  }

  get selectedItemCount(): number {
    return inventoryModuleState.getSelectedPalletCount;
  }

  get selectedItems(): Array<any> {
    return inventoryModuleState.getSelectedPallets;
  }

  
  get totalItems() {
    if (inventoryModuleState.palletPageData) {
      const items = inventoryModuleState.palletPageData.totalItems;
      return items ? items : 0;
    } else {
      return 0;
    }
  }

  
  get currentSortAscending() {
    return inventoryModuleState.palletDataSortAscending;
  }
  get currentSort() {
    return inventoryModuleState.palletDataSortKey;
  }

  unselectAll() {
    let pallets = this.selectedItems;

    pallets.forEach(summary => {
      inventoryModuleState.switchPalletSelectionStatus(summary.id);
    });
  }

  getComponentData(rowData) {
    return {
      on: {
        click: () => this.onRowClick(rowData),
        contextmenu: $event => this.onRightClicked(rowData, $event),
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }
  canMove() {
    return false;
  }
  putFeature() {
    return false;
  }
  sort(s) {
    this.$emit("sort", s);
  }

  onRightClicked(rowData, event) {
    event.preventDefault();
    if (!rowData.selected) inventoryModuleState.switchPalletSelectionStatus(rowData.id);

    this.rightClickLocation = { x: event.x, y: event.y };
  }
  onDoubleClicked(data) {
    inventoryModuleState.viewPalletShortcutAction({selectedItems: [data]});
  }
  onRowClick(rowData) {
    inventoryModuleState.switchPalletSelectionStatus(rowData.id);

    this.clearRightClick();
  }
  clearRightClick() {
    this.rightClickLocation = null;
    this.draggingData = false;
  }
  clickMenu(item) {
    let items = this.selectedItems;
    this.$store.dispatch(item.action, { selectedItems: items });
    this.clearRightClick();
  }
  onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    if (
      Math.ceil(scrollTop) + 1 + clientHeight >= scrollHeight &&
      !this.loading &&
      inventoryModuleState.palletPageData.totalItems > this.pallets.length
    ) {
      this.$emit("loadMoreData");
    }
  }

  getFieldClass(field, palletData) {
    var fieldClass = null;
    if (field.textAlign) {
      switch (field.textAlign) {
        case "right":
          fieldClass = "text-right";
          break;
        case "left":
          fieldClass = "text-left";
          break;
        case "center":
          fieldClass = "text-center";
          break;
        default:
          break;
      }
    }

    if(field.noWrap)
    {
      fieldClass += " text-nowrap";
    }

    return fieldClass;
  }

  getValue(object, path) {
    if (!path) return;
    return path.split(".").reduce((r, k) => (r ? r[k] : ""), object);
  }
}
